/* eslint-disable no-dupe-class-members */
import { observable, computed, action } from "mobx";

class FetchStore {
  @observable
  fetch = false;

  @action
  fetchOn() {
    this.fetch = true;
  }

  @action
  fetchOff() {
    this.fetch = false;
  }

  @computed
  get fetching() {
    return this.fetch;
  }
}

const store = new FetchStore();

export default store;



// WEBPACK FOOTER //
// ./src/stores/FetchStore.js